import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';
import { RenderRTE } from '@/components-2.0/structure/RenderRTE';
import { BLOCKS } from '@contentful/rich-text-types';
import ExclusiveBadge from '@/services/contentful/contentTypes/ExclusiveBadge';
import { siteLinkToWeb2ButtonProps } from '../Link/linkPropUtils';
import { ContentfulComponent } from '../type';
import { Options } from '@contentful/rich-text-react-renderer';
import { ButtonProps } from '@/ui-components/atoms/Button/Button';
import { Header } from '@/ui-components/organisms/Header/Header';
import { Grid } from '@/ui-components/atoms/Layout/Grid/Grid';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';

const HeaderCRC: ContentfulComponent<SiteHeader> = function ({ asset, pageContext, presentation }): React.JSX.Element {
    const headerAsset = asset as SiteHeader;
    const isInHorizontallyRenderedGroup = presentation?.styles?.groupLayoutContext === 'HorizontalGridLayout';
    const isGenericTemplate = presentation?.template === 'Generic';
    const alignment = isGenericTemplate ? presentation?.styles?.['Alignment'] as string | undefined : undefined;
    const headingAlignment = alignment === 'Left' ? 'left' : alignment === 'Center' ? 'center' : undefined;
    const columns = presentation?.styles?.['Columns'] as string | undefined;
    const headingColumns = (columns === '12 Columns' || columns === '10 Columns' || columns === '8 Columns') ? columns as '12 Columns' | '10 Columns' | '8 Columns' : undefined;
    const customRteRenderNodes: Options['renderNode'] = isInHorizontallyRenderedGroup
        ? {
              [BLOCKS.HEADING_1]: (node, children) => <span>{children}</span>,
              [BLOCKS.HEADING_2]: (node, children) => <span>{children}</span>,
          }
        : undefined;

    const headingAriaLabel = headerAsset.fields.headline ? documentToPlainTextString(headerAsset.fields.headline) : '';

    const headline = (
        <RenderRTE
            contentfulDoc={headerAsset.fields.headline}
            customRenderNodes={customRteRenderNodes}
            splitIntoChars={false}
        />
    );
    const subhead = headerAsset.fields.intro_copy ? (
        <RenderRTE contentfulDoc={headerAsset.fields.intro_copy} />
    ) : undefined;
    const links: ButtonProps[] = [];

    const badgeFields =
        headerAsset.fields.exclusive_content_badge && pageContext ? ExclusiveBadge(pageContext)?.fields : undefined;
    const badge = badgeFields
        ? {
              backgroundColor: badgeFields.background_color,
              image: (
                  // image size optimised based on badge size
                  <ImageWrapper
                      src={badgeFields.image.url}
                      alt={badgeFields.image.altText}
                      optimizedWidth={20}
                      optimizedHeight={20}
                  />
              ),
              ariaLabel: badgeFields.aria_label,
          }
        : undefined;

    for (let i = 0; i < 3; i += 1) {
        if (headerAsset.fields.links && headerAsset.fields.links[i]) {
            links.push(siteLinkToWeb2ButtonProps(headerAsset.fields.links[i].fields));
        }
    }

    const buttonSubtext = <RenderRTE contentfulDoc={asset.fields.cta_text} removeSpanTag />;

    const HeaderEl = (
        <Header
            badge={badge}
            eyebrow={headerAsset.fields.eyebrow}
            heading={headline}
            headingTag="h2"
            subhead={subhead}
            caption=""
            links={links}
            buttonSubtext={buttonSubtext}
            theme={isInHorizontallyRenderedGroup ? 'left' : 'center'}
            headingAriaLabel={headingAriaLabel}
            ctaGroupAlignment={isInHorizontallyRenderedGroup ? 'left' : 'center'}
            headingAlignment={headingAlignment}
            headingColumns={headingColumns}
        />
    );

    return <Grid container>{HeaderEl}</Grid>;
};

export default HeaderCRC;
